/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

 jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

 /**
  * Module to show Recently Viewed Products
  *
  * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
  * Dual licensed under the MIT and GPL licenses:
  * http://www.opensource.org/licenses/mit-license.php
  * http://www.gnu.org/licenses/gpl.html
  *
  * Modificat: produsele sunt incarcate prin /search?view=ajax_recently_viewed
  * (in loc de /collections/all?constraint=..., care nu mai returna nimic),
  * produsul curent este exclus, iar sectiunea se ascunde cand lista e goala.
  */

 Shopify.Products = (function() {
     var config = {
         howManyToShow: 3,
         howManyToStoreInMemory: 10,
         wrapperId: 'recently-viewed-products',
         templateId: 'recently-viewed-product-template',
         layout: 'slider',
         swipe: true,
         media: 'adapt',
         exclude: null,
         blockSelector: '.halo-recently-viewed-block',
         onComplete: null,
         onEmpty: null
     };
     var productHandleQueue = [];
     var wrapper = null;
     var template = null;
     var shown = 0;
     var cookie = {
         configuration: {
             expires: 90,
             path: '/',
             domain: window.location.hostname
         },
         name: 'shopify_recently_viewed',
         write: function(recentlyViewed) {
             jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
         },
         read: function() {
             var recentlyViewed = [];
             var cookieValue = jQuery.cookie(this.name);
             if (cookieValue !== null && cookieValue !== '') {
                 recentlyViewed = cookieValue.split(' ').filter(function(h) { return h; });
             }
             return recentlyViewed;
         },
         destroy: function() {
             jQuery.cookie(this.name, null, this.configuration);
         },
         remove: function(productHandle) {
             var recentlyViewed = this.read();
             var position = jQuery.inArray(productHandle, recentlyViewed);
             if (position !== -1) {
                 recentlyViewed.splice(position, 1);
                 this.write(recentlyViewed);
             }
         }
     };

     var hideBlock = function() {
         jQuery(config.blockSelector).remove();
         if (config.onEmpty) {
             try { config.onEmpty(); } catch (error) {}
         }
     };

     var finalize = function() {
         var items = wrapper.find('.item');
         if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');

         $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');

         wrapper.show();
         if (config.onComplete) {
             try {
                 config.onComplete();
             } catch (error) {}
         }
     };

     var moveAlong = function() {
         if (productHandleQueue.length && shown < config.howManyToShow) {
             var url = window.routes.root + '/products/' + productHandleQueue[0] + '?view=ajax_recently_viewed';

             jQuery.ajax({
                 type: 'get',
                 url: url,
                 cache: false,
                 success: function(product) {
                     wrapper.append(product);
                     productHandleQueue.shift();
                     shown++;
                     moveAlong();
                 },
                 error: function() {
                     cookie.remove(productHandleQueue[0]);
                     productHandleQueue.shift();
                     moveAlong();
                 }
             });
         } else {
             finalize();
         }
     };

     var initSlider = function() {
         var block = $(config.blockSelector),
             productGrid = block.find('.products-carousel'),
             itemToShow = productGrid.data('item-to-show'),
             itemDots = productGrid.data('item-dots'),
             itemDotsMb = productGrid.data('item-dots-mb'),
             itemArrows = productGrid.data('item-arrows'),
             itemArrowsMb = productGrid.data('item-arrows-mb');

         if (!productGrid.length || productGrid.hasClass('slick-initialized') || typeof productGrid.slick !== 'function') return;

         var show = (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') ? itemToShow : 1;
         var showTablet = (show == 5) ? show - 1 : show;

         productGrid.slick({
             mobileFirst: true,
             adaptiveHeight: true,
             vertical: false,
             infinite: true,
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: itemArrowsMb,
             dots: itemDotsMb,
             nextArrow: window.arrows.icon_next,
             prevArrow: window.arrows.icon_prev,
             rtl: window.rtl_slick,
             responsive: [
                 { breakpoint: 1599, settings: { arrows: itemArrows, dots: itemDots, slidesToShow: show, slidesToScroll: show } },
                 { breakpoint: 1024, settings: { arrows: itemArrows, dots: itemDots, slidesToShow: showTablet, slidesToScroll: showTablet } },
                 { breakpoint: 991, settings: { arrows: itemArrowsMb, dots: itemDotsMb, slidesToShow: 4, slidesToScroll: 4 } },
                 { breakpoint: 767, settings: { arrows: itemArrowsMb, dots: itemDotsMb, slidesToShow: 3, slidesToScroll: 3 } },
                 { breakpoint: 320, settings: { arrows: itemArrowsMb, dots: itemDotsMb, slidesToShow: 2, slidesToScroll: 2 } }
             ]
         });
     };

     var doAlong = function() {
         var handles = productHandleQueue.slice(0, config.howManyToShow);
         if (!handles.length) {
             hideBlock();
             return;
         }

         var searchUrl = (window.routes && window.routes.search_url) ? window.routes.search_url : '/search';
         var query = 'limit:' + handles.length +
             ' ratio:' + config.media +
             ' swipe:' + config.swipe +
             ' section:recently-viewed' +
             ' handles:' + handles.join(',');

         $.ajax({
             type: 'get',
             url: searchUrl,
             cache: false,
             data: {
                 view: 'ajax_recently_viewed',
                 type: 'product',
                 q: query
             },
             success: function(data) {
                 var html = $.trim(data || '');
                 var cards = $('<div>').html(html).children('.product');

                 if (!cards.length) {
                     hideBlock();
                     return;
                 }

                 var block = $(config.blockSelector);
                 var row = block.find('.recentlyViewed-row');
                 row.empty().append(cards);
                 block.removeClass('rv-hidden').addClass('rv-loaded');

                 if (config.layout == 'slider') initSlider();

                 if (config.onComplete) {
                     try { config.onComplete(); } catch (error) {}
                 }
             },
             error: function() {
                 hideBlock();
             }
         });
     };

     return {
         resizeImage: function(src, size) {
             if (size == null) {
                 return src;
             }

             if (size == 'master') {
                 return src.replace(/http(s)?:/, "");
             }

             var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

             if (match != null) {
                 var prefix = src.split(match[0]);
                 var suffix = match[0];

                 return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
             } else {
                 return null;
             }
         },

         showRecentlyViewed: function(params) {
             var params = params || {};

             jQuery.extend(config, params);

             productHandleQueue = cookie.read();

             // Nu afisam produsul pe care clientul il vede chiar acum.
             if (config.exclude) {
                 productHandleQueue = productHandleQueue.filter(function(h) { return h !== config.exclude; });
             }

             template = config.templateId;
             wrapper = jQuery('#' + config.wrapperId);

             config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

             if (template == 'recently-viewed-product-popup') {
                 if (config.howManyToShow && wrapper.length) moveAlong();
                 return;
             }

             if (config.howManyToShow && wrapper.length) {
                 doAlong();
             } else {
                 hideBlock();
             }
         },

         getConfig: function() {
             return config;
         },

         clearList: function() {
             cookie.destroy();
         },

         recordRecentlyViewed: function(params) {
             var params = params || {};

             jQuery.extend(config, params);

             var recentlyViewed = cookie.read();

             if (window.location.pathname.indexOf('/products/') !== -1) {
                 var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
                 if (!productHandle) return;

                 var position = jQuery.inArray(productHandle, recentlyViewed);
                 if (position !== -1) {
                     recentlyViewed.splice(position, 1);
                 }
                 recentlyViewed.unshift(productHandle);
                 recentlyViewed = recentlyViewed.slice(0, config.howManyToStoreInMemory);

                 cookie.write(recentlyViewed);
             }
         }
     };
 })();
